var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sort-icon"},[_c('Icon',{class:[_vm.sort=='up'?'on':''],attrs:{"type":"md-arrow-dropup"},on:{"click":function($event){return _vm.handleSort('up')}}}),_vm._v(" "),_c('Icon',{class:[_vm.sort=='down'?'on':''],attrs:{"type":"md-arrow-dropdown"},on:{"click":function($event){return _vm.handleSort('down')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }